/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
/**
 * 
 * @export
 * @interface KokpitFeatureNameListDto
 */
export interface KokpitFeatureNameListDto {
    /**
     * 
     * @type {number}
     * @memberof KokpitFeatureNameListDto
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof KokpitFeatureNameListDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof KokpitFeatureNameListDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitFeatureNameListDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitFeatureNameListDto
     */
    featureKey?: string | null;
}

/**
 * Check if a given object implements the KokpitFeatureNameListDto interface.
 */
export function instanceOfKokpitFeatureNameListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KokpitFeatureNameListDtoFromJSON(json: any): KokpitFeatureNameListDto {
    return KokpitFeatureNameListDtoFromJSONTyped(json, false);
}

export function KokpitFeatureNameListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KokpitFeatureNameListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'featureKey': !exists(json, 'featureKey') ? undefined : json['featureKey'],
    };
}

export function KokpitFeatureNameListDtoToJSON(value?: KokpitFeatureNameListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'featureKey': value.featureKey,
    };
}

